import { MapPin } from "lucide-react";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

/** Il valore salvato è l'ID del frigo nel locale; i valori legacy restano leggibili. */
export const PosizioneFrigoSelect = ({
  value, onChange, frigoriferi = [], posizioniLegacy = [], testId = "lotto-posizione",
}) => {
  const current = value || "";
  const missing = current && !frigoriferi.some(frigo => frigo.id === current);
  const previousName = posizioniLegacy.find(p => p.id === current)?.nome;

  return (
    <div className="min-w-0 space-y-2">
      <Label data-testid={`${testId}-label`} className="inline-flex items-center gap-1.5">
        <MapPin className="h-4 w-4" /> Posizione <span className="text-xs font-normal text-muted-foreground">(facoltativa)</span>
      </Label>
      <Select value={current || "__none__"} onValueChange={v => onChange(v === "__none__" ? "" : v)}>
        <SelectTrigger className="w-full min-w-0" data-testid={`${testId}-trigger`}>
          <SelectValue placeholder="Scegli da I miei frigo" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="__none__" data-testid={`${testId}-none`}>Non impostata</SelectItem>
          {frigoriferi.map(frigo => (
            <SelectItem key={frigo.id} value={frigo.id} data-testid={`${testId}-frigo-${frigo.id}`}>
              {frigo.nome}{frigo.tipologia ? ` · ${frigo.tipologia}` : ""}
              {frigo.temperatura_min != null && frigo.temperatura_max != null
                ? ` · ${frigo.temperatura_min} / ${frigo.temperatura_max} °C` : ""}
            </SelectItem>
          ))}
          {missing && (
            <SelectItem value={current} data-testid={`${testId}-precedente`}>
              {previousName ? `${previousName} (precedente)` : "Posizione precedente non disponibile"}
            </SelectItem>
          )}
        </SelectContent>
      </Select>
      {!frigoriferi.length && !current && (
        <p className="text-xs text-muted-foreground" data-testid={`${testId}-empty`}>Nessun frigo presente in questo locale.</p>
      )}
    </div>
  );
};